import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

interface StatCardProps {
  label: string;
  value: number;
  delta?: number;
  alert?: boolean;
  loading?: boolean;
  suffix?: string;
}

export function StatCard({ label, value, delta, alert, loading, suffix }: StatCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-surface)] p-4 flex flex-col gap-1',
        alert && 'border-[var(--border-error)]',
      )}
    >
      <p className="text-xs text-[var(--text-tertiary)] uppercase tracking-wide">{label}</p>
      {loading ? (
        <Skeleton className="h-8 w-16" />
      ) : (
        <p className="text-2xl font-semibold tabular-nums text-[var(--text-primary)]">
          {value.toLocaleString()}
          {suffix && (
            <span className="text-sm font-normal text-[var(--text-tertiary)] ml-1">{suffix}</span>
          )}
        </p>
      )}
      {!loading && delta !== undefined && delta !== 0 && (
        <p
          className={cn(
            'text-xs font-medium',
            delta > 0 ? 'text-[var(--status-green-text)]' : 'text-[var(--status-red-text)]',
          )}
        >
          {delta > 0 ? `+${delta}` : delta} vs yesterday
        </p>
      )}
    </div>
  );
}
